var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',[_vm._v("Columnas")]),_c('v-btn-toggle',{attrs:{"color":"warning","group":""}},_vm._l((_vm.itemsRows),function(item){return _c('v-btn',{attrs:{"value":item.ChcID},on:{"click":function($event){return _vm.select(item)}}},[_vm._v(" "+_vm._s(item.ChcDescription)+" ")])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }